<div class="banner-sec">
  <div class="app-banner-area">
    <div class="banner-msg">
      <h3>{{'CP_BANNER_HEADING' | translate}}</h3>
      <span class="banner-sub-msg mobile-only">{{'CP_BANNER_SUB_HEADING_MOBILE' | translate}}</span>
      <span class="banner-sub-msg tablet-only">{{'CP_BANNER_SUB_HEADING_TABLET' | translate}}</span>
    </div>
    <div class="desktop-download">
      <div class="download-link">
        <div class="app-store" (click)="takeToAppleStore()">
          <img src="../../../assets/images/appStore.png" alt="App Store" />
        </div>
        <div class="play-store" (click)="takeToGooglePlayStore()">
          <img src="../../../assets/images/playStore.png" alt="Google Play Store" />
        </div>
      </div>
      <div class="qr-code-area">
        <img  src="../../../assets/images/qr-code.png" alt="QR Code" />
      </div>


    </div>
    <div class="download-sec">
      <div class="publish-btn">
        <button class="publish-button" (click)="triggerGoToApp()">
          <span>{{'CP_SM_OPEN_IN_APP_BTN_TXT' | translate}}</span>
          <ng-container *ngIf="showSpinner$ | async" >
            <div class="spin-in-btn">
              <div class="spinner-border spinner"></div>
            </div>
          </ng-container>
        </button>
      </div>
    </div>
  </div>
</div>
